export class ContentType {
  public static JSON = 'application/json';
  public static CSV = 'text/csv';
  public static URLEncoded = 'application/x-www-form-urlencoded';
}
